const e=async(e,t,n=!1)=>{await e.post(`/auth/mfa/method/enable`,{method:t,setAsPreferred:n})};export{e as enableMfaMethod};
//# sourceMappingURL=enable-mfa-method.mjs.map